export function ConnectPlatformDeepLink(platform: string): string {
  return `/settings/integrations?connect=${encodeURIComponent(platform)}`;
}
